// IE 11 support for bootstrap-vue
import 'babel-polyfill'

import cementConfig from 'cementConfig'

import Vue from 'vue'
import App from './App.vue'

// bootstrap 4 support
import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// Google Tag Manager
import VueGtm from '@gtm-support/vue2-gtm'

// fontawesome support
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleDoubleRight, faAngleLeft } from '@fortawesome/pro-regular-svg-icons'

import router from './router'
import store from './store'

library.add(faAngleDoubleRight)
library.add(faAngleLeft)

Vue.use(BootstrapVue)
Vue.component('font-awesome-icon', FontAwesomeIcon)

if (cementConfig.enableGTM) {
  Vue.use(VueGtm, {
    id: 'GTM-MDSP',
    vueRouter: router
  })
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
